import createLogger from 'components/logger/Logger';

const Logger = createLogger('AccountNewsletterPreferences');

export default class AccountNewsletterPreferences {
  constructor() {
    Logger.info('Initialized');

    this.allTopicsCheckbox = document.querySelector('#allNewsletterPreferences');
    this.newsletterPreferences = document.querySelectorAll('ul.newsletterPreferences input');
    this.checkedInputs = Array.prototype.reduce.call(
      this.newsletterPreferences,
      (acc, input) => (input.checked ? ++acc : acc),
      0
    );

    this.handleAllTopicsCheckboxState();
    this.bindEvents();
  }

  bindEvents() {
    this.allTopicsCheckbox.addEventListener('click', e => {
      e.target.classList.remove('indeterminate');

      if (e.target.checked) {
        Array.prototype.forEach.call(this.newsletterPreferences, input => (input.checked = true));
        this.checkedInputs = this.newsletterPreferences.length;
      } else {
        Array.prototype.forEach.call(this.newsletterPreferences, input => (input.checked = false));
        this.checkedInputs = 0;
      }
    });

    Array.prototype.forEach.call(this.newsletterPreferences, checkbox => {
      checkbox.addEventListener('click', event => {
        event.target.checked ? ++this.checkedInputs : --this.checkedInputs;

        this.handleAllTopicsCheckboxState();
      });
    });

    if (AppState.isMobile) {
      const form = document.querySelector('#newsletterForm');
      const formFooter = form.querySelector('.formFooter');

      formFooter.classList.add('newsletterForm');
      document.body.appendChild(formFooter);

      const submitButton = document.querySelector('.js-communication-preferences-save-btn');
      if (submitButton) {
        submitButton.addEventListener('click', () => {
          form.submit();
        });
      }
    }

    const tooltips = document.querySelectorAll('.tooltip-wrapper');

    tooltips.forEach(tooltip => {
      this.positionTooltip(tooltip, document.body);
    });

    window.addEventListener('resize', () => {
      setTimeout(() => {
        tooltips.forEach(tooltip => {
          this.positionTooltip(tooltip, document.body);
        });
      }, 500);
    });
  }

  handleAllTopicsCheckboxState() {
    const newsletterFormElement = document.getElementById('newsletterForm');
    const NewsletterCRMPreferencesOn = newsletterFormElement?.classList?.contains(
      'js-newsletter-crm-preferences-on'
    );

    if (NewsletterCRMPreferencesOn) {
      this.allTopicsCheckbox.checked = this.checkedInputs === this.newsletterPreferences.length;
    } else {
      this.allTopicsCheckbox.checked =
        this.checkedInputs === this.newsletterPreferences.length || this.checkedInputs > 0;
    }

    this.allTopicsCheckbox.classList.toggle(
      'indeterminate',
      NewsletterCRMPreferencesOn &&
        this.checkedInputs > 0 &&
        this.checkedInputs < this.newsletterPreferences.length
    );
  }

  getElementCoords(element) {
    const box = element.getBoundingClientRect();

    return {
      top: box.top + window.scrollY,
      right: box.right + window.scrollX,
      bottom: box.bottom + window.scrollY,
      left: box.left + window.scrollX,
    };
  }

  getTooltipIndents(element, parentElement) {
    const tooltipCoords = this.getElementCoords(element);
    const parentCoords = this.getElementCoords(parentElement);

    return {
      topIndent: parentCoords.top - tooltipCoords.top,
      rightIndent: tooltipCoords.right - parentCoords.right,
      bottomIndent: tooltipCoords.bottom - parentCoords.bottom,
      leftIndent: parentCoords.left - tooltipCoords.left,
    };
  }

  positionTooltip(tooltip, parentElement) {
    tooltip.style.maxWidth = `${
      parentElement.clientWidth - 84 < 350 ? parentElement.clientWidth - 84 : 350
    }px`;

    const { rightIndent, leftIndent } = this.getTooltipIndents(tooltip, parentElement);

    const arrow = tooltip.parentElement.querySelector('.tooltip-arrow');
    const shift = parseInt(window.getComputedStyle(arrow).getPropertyValue('left'));

    if (rightIndent > 0) {
      tooltip.style.left = `${-1 * rightIndent - 42}px`;
      arrow.style.left = `${shift + rightIndent + 42}px`;
    } else if (leftIndent > 0) {
      tooltip.style.left = `${leftIndent + 42}px`;
      arrow.style.left = `${shift - leftIndent - 42}px`;
    }
  }
}
